import visual from 'assets/images/community/visual.png';

export const krInquiry = {
  title: `커뮤니티`,
  subTitle: `Community`,
  subject: `견적문의`,
  subjectDesc: `Inquiry`,
  visual,
  question:{
    regUserName:{
      label: '성함',
      placeholder: `성함을 입력해 주세요`
    },
    regUserPhone:{
      label: '연락처',
      placeholder: `-빼고 숫자만 입력`
    },
    regUserEmail:{
      label: '이메일',
      placeholder: `example@example.com`
    },
    title:{
      label: '문의 제목',
      placeholder: `문의 제목을 입력해 주세요`
    },
    content:{
      label: '문의 내용',
      placeholder: `문의하실 내용을 적어주세요.

[작성 예시]
- 대상 돈사: 비육사 / 모돈사(분만사·임신사) / 자돈사 / 육성사 등
- 규모: 사육 두수, 동 수, 면적(㎡ 또는 평)
- 환기 유형: 천장형(천장 입기) / 복도형(복도 입기)
- 도면: 첨부 여부 (평면도·배치도 등)`
    },
    password:{
      label: '비밀번호',
      placeholder: '4자리 이상 입력 (열람 시 필요)'
    },
    passwordCheck:{
      label: '비밀번호 확인',
      placeholder: '비밀번호를 다시 입력'
    }
  },
  privateLabel: `비공개(비밀글)로 문의하기 — 작성자만 비밀번호로 열람할 수 있어요`,
  uploadFile: `파일 첨부`,
  uploadInputLabel: `파일 선택`,
  uploadDesc: `선택된 파일 없음`,
  stats: {
    label: `지금까지 접수된 견적문의`,
    unit: `건`,
    desc: `많은 고객님들이 팜인과 함께하고 있습니다. 부담 없이 문의해 주세요!`,
    recentTitle: `최근 견적문의`,
    empty: `등록된 견적문의가 없습니다.`
  },
  agree: `개인정보처리방침에 동의합니다.`,
  agreeView: `보기`,
  submitBtn: `문의하기`,
  messages: {
    requiredPolicy: '개인 정보 보호 정책에 동의해주세요.',
    required: '필수 입력항목 입니다.',
    saveDone: '문의가 등록되었습니다.',
    invalidEmail: '잘못된 이메일 주소 입니다.',
    invalidPhone: '숫자만 입력해주세요.'
  }
};

export const enInquiry = {
  title: `커뮤니티_EN`,
  subTitle: `Community`,
  subject: `견적문의_EN`,
  subjectDesc: `Inquiry`,
  visual,
  question:{
    regUserName:{
      label: '성함',
      placeholder: `성함을 입력해 주세요`
    },
    regUserPhone:{
      label: '연락처',
      placeholder: `-빼고 숫자만 입력`
    },
    regUserEmail:{
      label: '이메일',
      placeholder: `example@example.com`
    },
    title:{
      label: '문의 제목',
      placeholder: `문의 제목을 입력해 주세요`
    },
    content:{
      label: '문의 내용',
      placeholder: `문의하실 내용을 적어주세요.

[작성 예시]
- 대상 돈사: 비육사 / 모돈사(분만사·임신사) / 자돈사 / 육성사 등
- 규모: 사육 두수, 동 수, 면적(㎡ 또는 평)
- 환기 유형: 천장형(천장 입기) / 복도형(복도 입기)
- 도면: 첨부 여부 (평면도·배치도 등)`
    },
    password:{
      label: '비밀번호',
      placeholder: '4자리 이상 입력 (열람 시 필요)'
    },
    passwordCheck:{
      label: '비밀번호 확인',
      placeholder: '비밀번호를 다시 입력'
    }
  },
  privateLabel: `비공개(비밀글)로 문의하기 — 작성자만 비밀번호로 열람할 수 있어요`,
  uploadFile: `파일 첨부`,
  uploadInputLabel: `파일 선택`,
  uploadDesc: `선택된 파일 없음`,
  stats: {
    label: `지금까지 접수된 견적문의`,
    unit: `건`,
    desc: `많은 고객님들이 팜인과 함께하고 있습니다. 부담 없이 문의해 주세요!`,
    recentTitle: `최근 견적문의`,
    empty: `등록된 견적문의가 없습니다.`
  },
  agree: `개인정보처리방침에 동의합니다.`,
  agreeView: `보기`,
  submitBtn: `문의하기`,
  messages: {
    requiredPolicy: '개인 정보 보호 정책에 동의해주세요.',
    required: '필수 입력항목 입니다.',
    saveDone: '문의가 등록되었습니다.',
    invalidEmail: '잘못된 이메일 주소 입니다.',
    invalidPhone: 'Please input only number'
  }
};
